export enum QuoteButtonType {
    Approve = 1,
    Decline = 2,
    RequestChanges = 3,
}